export const INVALID_CSRF_ERROR_CODE = 'CF004';
export const INVALID_HURDLE_OTP_ERROR_CODE = 'SEN1104';
